module.exports = __webpack_public_path__ + "static/media/tekieLogo.29729225.png";